import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.date.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

import { useRoute } from 'vue-router';
import { computed } from 'vue';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4a7a81e0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "Footer mt-2xl border-t border-solid border-zinc-700"
};
var _hoisted_2 = {
  "class": "py-lg"
};
var _hoisted_3 = {
  "class": "container relative flex items-center justify-between"
};
var _hoisted_4 = {
  "class": "Footer__currency"
};
var _hoisted_5 = {
  "class": "Footer__links"
};
var _hoisted_6 = ["href"];
var _hoisted_7 = {
  "class": "Footer__social flex justify-end items-center"
};
var _hoisted_8 = ["href"];
var _hoisted_9 = {
  "class": "text-center text-zinc-500"
};
var _hoisted_10 = {
  "class": "container"
};
var _hoisted_11 = {
  "class": "relative flex items-center justify-between py-lg border-y border-solid border-zinc-700"
};
var _hoisted_12 = {
  "class": "Footer__grid"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Products", -1);
});
var _hoisted_14 = {
  "class": "PBDropdown__list"
};
var _hoisted_15 = {
  "class": "PBDropdown__item"
};
var _hoisted_16 = {
  href: "https://bequant.pro",
  target: "_blank"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("span", null, "BEQUANT Prime Brokerage"), /*#__PURE__*/_createElementVNode("span", null, "Monitor & Manage Assets")], -1);
});
var _hoisted_18 = {
  "class": "PBDropdown__item"
};
var _hoisted_19 = {
  href: "https://bequant.io",
  target: "_blank"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("span", null, "BEQUANT Exchange"), /*#__PURE__*/_createElementVNode("span", null, "Buy & Sell Cryptocurrency")], -1);
});
var _hoisted_21 = {
  "class": "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
};
var _hoisted_22 = {
  "class": "Footer__terms"
};
var _hoisted_23 = {
  "class": "flex items-center text-sm"
};
var _hoisted_24 = ["href"];
var _hoisted_25 = {
  key: 0,
  "class": "text-zinc-500 px-2xl py-lg text-sm"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "mb-md"
  }, " All information contained on this Bequant website is for general use only. NOTHING ON THIS BEQUANT WEBSITE constitutes investment advice, recommendation or investment research. It MAY NOT BE RELIED UPON BY YOU FOR ANY PURPOSE, INCLUDING, WITHOUT LIMITATION, IN MAKING ANY INVESTMENT DECISION. WE CANNOT GUARANTEE OR WARRANT THE SECURITY OF BEQUANT OR THE ACCURACY, COMPLETENESS, CURRENCY, RELIABILITY OR SUITABILITY OF ANY OF THE CONTENT ON THIS WEBSITE. SOME OF THE CONTENT ON THE BEQUANT WEBSITE IS PROVIDED TO BEQUANT BY INDEPENDENT THIRD PARTIES (SUCH AS EXCHANGES) WHOM BEQUANT HAS NO CONTROL OVER AND AS SUCH, BEQUANT CANNOT VERIFY THE ACCURACY OR COMPLETENESS OF SUCH CONTENT. AS A RESULT, YOUR USE OF THE INFORMATION ON THE BEQUANT WEBSITE IS AT YOUR SOLE RISK AND WE CANNOT ACCEPT ANY LIABILITY FOR LOSS OR DAMAGE SUFFERED BY YOU ARISING FROM SUCH USE. YOU SHOULD TAKE ADEQUATE STEPS TO VERIFY THE ACCURACY AND COMPLETENESS OF ANY INFORMATION CONTAINED ON THE BEQUANT WEBSITE. ", -1);
});
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "mb-md"
  }, " You must make your own assessment as to the suitability for any purpose of any content on the Bequant website. WE STRONGLY RECOMMEND THAT YOU OBTAIN INDEPENDENT PROFESSIONAL ADVICE FROM A SUITABLY QUALIFIED SPECIALIST BEFORE TAKING ANY ACTION ON THE BASIS OF THE CONTENT ON THE BEQUANT WEBSITE. ", -1);
});
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" You should be aware of the risks associated with digital asset investment. Please remember that past performance is not necessarily a guide to the future. DON’T INVEST UNLESS YOU’RE PREPARED TO LOSE ALL THE MONEY YOU INVEST. THIS IS A HIGH-RISK INVESTMENT AND YOU SHOULD NOT EXPECT TO BE PROTECTED IF SOMETHING GOES WRONG. "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://bequant.pro/risk-disclosure-statement",
    target: "_blank",
    "class": "text-zinc-500 underline hover:text-zinc-600"
  }, "Take 2 mins to learn more"), /*#__PURE__*/_createTextVNode(". ")], -1);
});
var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "mb-md"
  }, " Please be advised that the financial information presented on this page is provided for informational purposes only. It is not intended for use in official financial or regulatory reporting. SOME OF THE CONTENT ON THE BEQUANT WEBSITE IS PROVIDED TO BEQUANT BY INDEPENDENT THIRD PARTIES (SUCH AS EXCHANGES) WHOM BEQUANT HAS NO CONTROL OVER AND AS SUCH, BEQUANT CANNOT VERIFY THE ACCURACY OR COMPLETENESS OF SUCH CONTENT. We make reasonable efforts to ensure the reliability and accuracy of the information provided, but we do not guarantee its accuracy, completeness, or suitability for any specific purpose. ", -1);
});
var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "mb-md"
  }, " The information on this page may not be up-to-date, comprehensive, or complete and should not be relied upon for making financial decisions or financial reporting. We are not responsible for any errors or omissions, or for the results obtained from the use of this information. Any reliance you place on such information is strictly at your own risk. ", -1);
});
var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" We recommend consulting with professional advisers before making any financial decisions based on the information provided here. By using this page, you agree that the website owners, and affiliated entities are not liable for any decisions made based on the information provided "), /*#__PURE__*/_createElementVNode("a", {
    href: "https://bequant.pro/risk-disclosure-statement",
    target: "_blank",
    "class": "text-zinc-500 underline hover:text-zinc-600"
  }, "here"), /*#__PURE__*/_createTextVNode(". ")], -1);
});
export default {
  __name: 'Footer',
  props: {
    empty: Boolean
  },
  setup: function setup(__props) {
    var VUE_APP_API_URL = process.env.VUE_APP_API_URL;
    var route = useRoute();
    var links = [{
      url: "https://intercom.help/bequant/en/collections/3030720-bequant-prime-brokerage",
      text: "Support centre"
    }, {
      url: "https://bequant.pro/company/about#contact_us_form",
      text: "Connect"
    }, {
      url: "https://insights.bequant.pro",
      text: "Insights"
    }, {
      url: "".concat(VUE_APP_API_URL, "/uapi-docs/"),
      text: "API"
    }];
    var terms = [{
      url: "https://bequant.pro/legal-information",
      text: "Legal information"
    }, {
      url: "https://bequant.pro/terms-of-service",
      text: "Terms of service"
    }];
    var socials = [{
      url: "https://twitter.com/bequant_group",
      width: 18,
      height: 14,
      name: "twitter"
    }, {
      url: "https://www.facebook.com/BEQUANTGROUP/",
      width: 9,
      height: 16,
      name: "facebook"
    }, {
      url: "https://www.linkedin.com/company/bequantgroup/",
      width: 14,
      height: 14,
      name: "linkedin"
    }, {
      url: "https://medium.com/@BEQUANT",
      width: 19,
      height: 15,
      name: "medium"
    }];
    var isReports = computed(function () {
      return ['trades', 'transactions', 'turnover', 'pnl'].includes(route.name);
    });
    var noDisclaimer = computed(function () {
      return ['outages', 'login', 'register', 'confirm-registration'].includes(route.name);
    });
    return function (_ctx, _cache) {
      var _component_CurrencySelector = _resolveComponent("CurrencySelector");
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_PBDropdown = _resolveComponent("PBDropdown");
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_CurrencySelector, {
        disabled: __props.empty
      }, null, 8, ["disabled"])]), _createElementVNode("ul", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, function (link, index) {
        return _createElementVNode("li", {
          key: index
        }, [_createElementVNode("a", {
          href: link.url,
          target: "_blank"
        }, _toDisplayString(link.text), 9, _hoisted_6)]);
      }), 64))]), _createElementVNode("ul", _hoisted_7, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, function (item, index) {
        return _createElementVNode("li", {
          key: index,
          "class": "ml-sm"
        }, [_createElementVNode("a", {
          href: item.url,
          "class": _normalizeClass([item.name, "flex justify-center items-center w-[32px] h-[32px] rounded-md border border-solid border-zinc-600 transition-all hover:bg-white hover:border-white"]),
          target: "_blank"
        }, [_createVNode(_component_PBIcon, {
          name: item.name,
          w: item.width,
          h: item.height
        }, null, 8, ["name", "w", "h"])], 10, _hoisted_8)]);
      }), 64))])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_PBDropdown, {
        selectable: false,
        chevron: false,
        top: "",
        left: ""
      }, {
        icon: _withCtx(function () {
          return [_createElementVNode("div", null, [_createVNode(_component_PBIcon, {
            name: "grid",
            w: 18,
            h: 18
          }), _hoisted_13])];
        }),
        menu: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("a", _hoisted_16, [_createVNode(_component_PBIcon, {
            name: "logo-mini",
            w: 24,
            h: 24
          }), _hoisted_17])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", null, [_createElementVNode("a", _hoisted_19, [_createVNode(_component_PBIcon, {
            name: "logo-mini",
            w: 24,
            h: 24
          }), _hoisted_20])])])])];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_21, " © 2018 - " + _toDisplayString(new Date().getFullYear()) + " BEQUANT ", 1), _createElementVNode("div", _hoisted_22, [_createElementVNode("ul", _hoisted_23, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(terms, function (link, index) {
        return _createElementVNode("li", {
          key: index,
          "class": "font-semibold"
        }, [_createElementVNode("a", {
          href: link.url,
          target: "_blank"
        }, _toDisplayString(link.text), 9, _hoisted_24)]);
      }), 64))])])])])]), !_unref(noDisclaimer) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [!_unref(isReports) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_26, _hoisted_27, _hoisted_28], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_29, _hoisted_30, _hoisted_31], 64))])) : _createCommentVNode("", true)]);
    };
  }
};